(() => {
  const repairs = new Map([
    ['/products/zenia-free-size-adjustable-ihram-belt-with-phone-holder-waist-belt-anti-theft-for-hajj-umrah', '/products/anti-theft-waist-bag-and-ihram-belt-large'],
    ['/products/arabic-to-english-noble-quran-pocket-size-translated-by-dr-muhammad-muhsin-khan-dr-muhammad-taqi-ud-din-al-hillali-34gm', '/products/tajweed-quran-pocket-english'],
    ['/products/unisex-water-shoes-quick-drying-aqua-shoes-summer-outdoor-swimming-slipper-on-surf-beach-water-shoes-women-men', '/collections/travel-essentials-for-umrah'],
    ['/products/hopomer-sleep-mask-eye-plugs', '/collections/travel-essentials-for-umrah'],
    ['/products/muslim-prayer-rug-islamic-prayer-mat-back-support-thick-padded-islam-janamaz-for-women-and-men-soft-foldable-travel-sajadah-carpet-black', '/collections/prayer-guidance'],
    ['/products/padded-prayer-mat', '/collections/prayer-guidance']
  ]);

  const repairLinks = (root = document) => {
    root.querySelectorAll('a[href]').forEach((link) => {
      let url;
      try { url = new URL(link.href, window.location.origin); } catch { return; }
      if (url.origin !== window.location.origin) return;
      const replacement = repairs.get(url.pathname);
      if (!replacement) return;
      url.pathname = replacement;
      link.href = url.pathname + url.search + url.hash;
      link.dataset.ksRepairedArchivedProductLink = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => repairLinks(), { once: true });
  } else {
    repairLinks();
  }
})();
